import { NavLink ,DisabledPrompt} from '@bcm-dev/bcms-vite';
import React from 'react';
import { SVGAsset } from 'res';
import './styles.css';

export default function WidgetContainer(props) {
  const className = props.className ?? "";
  const headerText = props.headerText ?? "";
  const dataPoint = props.dataPoint ?? false;
  return(
    <div className={className + " widget-container"}>
      <div className="widget-title-container">
      {dataPoint !== false && <p><b data-point={dataPoint}>{headerText}</b></p>}
      {dataPoint === false && <p><b>{headerText}</b></p>}
      </div>
      <div className="widget-content-container">
        {props.children}
      </div>
    </div>
  );
}

export function WidgetNavItem(props) {
  const className = props.className ?? "";
  const text = props.text ?? "";
  const icon = props.icon ?? "CardIcon";
  const route = props.route ?? "";
  const dataPoint = props.dataPoint ?? false;
 const item =  <NavLink to={route}  className={className + " widget-nav-item flex-container flex-horizontal align-center-container bottom-border"}>
      <span className="icon-container set-width">
        <SVGAsset id={ icon } />
      </span>
      <div className="flex-width flex-container flex-vertical">
        {dataPoint !== false && <p><span data-point={dataPoint}>{text}</span></p>}
        {dataPoint === false && <p><span >{text}</span></p>}
        <p className="rewards-text">Available Points 50k</p>
      </div>
      {props.children}       
    </NavLink>;

 const disabledItem =
    <DisabledPrompt>
      {item}
    </DisabledPrompt>
    
  return (
    <span className="widget-nav-item-container">
      { route !== "" && <span>{ item }</span> }
      { route === "" && <span>{ disabledItem }</span> }
    </span>
  )
}